import { addressActionTypes } from '@Actions/addressActions';

const AddressReducer = (state = { }, action) => {
  switch (action.type) {
  case addressActionTypes.GET_ADDRESSES.LOADING: {
    const { getAddressesLoading } = action;
    return {
      ...state,
      getAddressesLoading,
    };
  }
  case addressActionTypes.GET_ADDRESSES.SUCCESS: {
    const { addresses } = action;
    if (addresses?.type === 'SELLER') {
      return {
        ...state,
        sellerAddresses: addresses,
      };
    }
    if (addresses?.type === 'CUSTOMER') {
      return {
        ...state,
        customerAddresses: addresses,
      };
    }

    return {
      ...state,
      tenantAddresses: addresses,
    };
  }
  case addressActionTypes.CREATE_ADDRESS.LOADING: {
    const { createAddressLoading } = action;
    return {
      ...state,
      createAddressLoading,
    };
  }
  case addressActionTypes.UPDATE_ADDRESS.LOADING: {
    const { updateAddressLoading } = action;
    return {
      ...state,
      updateAddressLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default AddressReducer;
